var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6249 10.8054C9.82182 10.2452 8.8451 9.91667 7.7916 9.91667C5.24449 9.91667 3.14596 11.8372 2.8652 14.3093C2.84533 14.4842 2.83539 14.5717 2.87032 14.6562C2.8989 14.7253 2.96076 14.7945 3.02621 14.8307C3.1062 14.875 3.20412 14.875 3.39994 14.875H7.04413M10.6249 4.95833C10.6249 6.52314 9.35645 7.79167 7.7916 7.79167C6.2268 7.79167 4.95828 6.52314 4.95828 4.95833C4.95828 3.39353 6.2268 2.125 7.7916 2.125C9.35645 2.125 10.6249 3.39353 10.6249 4.95833Z",
    stroke: "#F45600",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0416 11.3334V12.75",
    stroke: "#F45600",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 14.1666H11.3334",
    stroke: "#F45600",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2306 12.0416H9.91671C9.52549 12.0416 9.20837 12.3587 9.20837 12.75V15.5833C9.20837 15.9745 9.52549 16.2916 9.91671 16.2916H14.1667C14.5579 16.2916 14.875 15.9745 14.875 15.5833V12.75C14.875 12.3587 14.5579 12.0416 14.1667 12.0416H12.9861",
    stroke: "#F45600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEss);
export default __webpack_public_path__ + "static/media/ess.9e48b725516553d6a8614161a1eb519c.svg";
export { ForwardRef as ReactComponent };